module.exports = __webpack_public_path__ + "static/credit-counselling-society-logo-8f6108bff76fffe7e5733a910025ff0d.png";